export default {
  welcome: 'Welcome',
  signInToAccount: 'Sign in to your account',
  createNewAccount: 'Create a new account',
  noAccount: "Don't have an account?",
  signUpAction: 'Sign up',
  haveAccount: 'Already have an account?',
  logInAction: 'Log in',
  loginTab: 'Login',
  signUpTab: 'Sign Up',
  email: 'Email',
  emailPlaceholder: 'user@example.com',
  password: 'Password',
  passwordPlaceholder: '••••••••',
  confirmPassword: 'Confirm Password',
  name: 'Name',
  namePlaceholder: 'John Doe',
  signIn: 'Sign In',
  signingIn: 'Signing in...',
  createAccount: 'Create account',
  creatingAccount: 'Creating account...',
  agreeToTerms: 'I agree to the terms of service and privacy policy',
  agreeToTermsPrefix: 'I agree to the',
  termsOfService: 'terms of service',
  agreeToTermsAnd: 'and',
  privacyPolicy: 'privacy policy',
  refundPolicy: 'refund policy',
  pendingApproval: 'Pending approval',
  pendingApprovalDescription:
    'Your request to join the organization has been submitted. An organization owner will review it shortly.',
  refreshAfterApproval:
    'Check your status after you receive approval to continue.',
  checkStatus: 'Check status',
  checkingStatus: 'Checking status...',
  backToLogin: 'Back to login',
  pendingApprovalStillPending:
    'Your request is still waiting for organization admin approval.',
  verifyEmailSentTitle: 'Confirm your email',
  verifyEmailSentDescription:
    'We sent a confirmation link to {{email}}. Open it from your inbox to activate your account.',
  verifyEmailSentDescriptionNoEmail:
    'We sent a confirmation link to your email. Open it from your inbox to activate your account.',
  verifyEmailResend: 'Resend the email',
  verifyEmailResendCooldown: 'Resend in {{seconds}}s',
  verifyEmailResent: 'A new confirmation email has been sent.',
  verifyEmailLoading: 'Confirming your email…',
  verifyEmailExpired: 'This link has expired',
  verifyEmailExpiredDescription:
    'Request a new confirmation email and try again.',
  verifyEmailInvalid: 'This link is no longer valid',
  verifyEmailInvalidDescription:
    'It may have already been used. Sign in to continue.',
  emailChangeConfirming: 'Confirming your new email…',
  emailChangeDone: 'Your email is now {{email}}',
  emailChangeAlreadyDone: 'This email is already confirmed',
  emailChangeAlreadyDoneDescription: 'Sign in with {{email}}.',
  emailChangeExpired: 'This link has expired',
  emailChangeExpiredDescription:
    'Request a new link in Account Settings. Your current email still works.',
  emailChangeInvalid: 'This link is no longer valid',
  emailChangeInvalidDescription:
    'Use the latest link we sent, or request a new one in Account Settings.',
  emailChangeTaken: 'This email is already in use',
  emailChangeTakenDescription:
    'Another account uses this address now. Your current email still works.',
  emailChangeGoToSettings: 'Account Settings',
  verifyEmailGoToLogin: 'Log in',
  loginEmailNotVerified: 'Confirm your email before signing in.',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  validation: {
    nameMinLength: 'Name must be at least 2 characters',
    invalidEmail: 'Please enter a valid email address',
    passwordPolicy:
      'Password must be 8 to 50 characters and include uppercase and lowercase letters, a digit, and a special character.',
    termsRequired: 'You must agree to the terms and conditions',
    passwordsDoNotMatch: 'Passwords do not match',
  },
  errors: {
    invalidCredentials: 'Invalid email or password',
    emailInUse: 'A user with this email already exists',
    invalidEmail: 'Please enter a valid email',
    serverUnavailable: 'Could not reach the server. Please try again later',
    networkError: 'Could not reach the server. Please try again later',
    unknown: 'Something went wrong. Please try again later',
  },
}
